import React from 'react';

export const getNestedValue = (obj: any, key: string) => {
    const value = key.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);

    if (key === 'requestDate' && value) {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('en-GB');
        }
    }

    return value;
};

/**
 * Get decoded query params
 * - If key is provided → returns single decoded value
 * - If key is NOT provided → returns all decoded params
 *
 * @param key - query param name (optional)
 * @param search - window.location.search
 */
export const getDecodedQueryParam = (
    key?: string,
    search: string = window.location.search
): string | Record<string, string> | null => {
    const params = new URLSearchParams(search);

    // 🔹 Return all decoded params
    if (!key) {
        const result: Record<string, string> = {};

        params.forEach((value, paramKey) => {
            try {
                result[paramKey] = decodeURIComponent(value);
            } catch {
                result[paramKey] = value;
            }
        });

        return result;
    }

    // 🔹 Return single decoded param
    const value = params.get(key);
    if (!value) return null;

    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};
export function getDetailsValue(value: any, fallback: string = '-'): string {
    if (
        value === null ||
        value === undefined ||
        value === 'null' ||
        value === 'null null' ||
        (typeof value === 'string' && value.trim() === '')
    ) {
        return fallback;
    }
    return String(value);
}

export const renderLabelWithAsterisk = (label?: string) => {
    if (!label) return null;

    const hasAsterisk = label.trim().endsWith('*');

    if (!hasAsterisk) return label;

    return (
        <>
            {label.replace('*', '')}
            <span style={{ color: '#C62828', marginLeft: 2 }}>*</span>
        </>
    );
};

export const getFormattedAmount = (value: string) => {
    if (!value || value.trim() === '-') return '-';

    // Extract currency (non-numeric prefix)
    const currency = value.match(/^[^\d]+/)?.[0]?.trim() || '';

    // Extract number
    const numberPart = Number(value.replace(/[^\d]/g, ''));

    if (isNaN(numberPart)) return value;

    const formattedNumber = new Intl.NumberFormat('en-US').format(numberPart);

    return currency
        ? currency.endsWith(' ')
            ? `${currency}${formattedNumber}`
            : `${currency} ${formattedNumber}`
        : formattedNumber;
};